import React, { useState, ReactNode, useEffect } from "react";
import Header from '../../layout/header';
import AdminNavbar from './AdminNavbar'
import "./layout.css";
import { currentLang } from "../../utility/index";
interface AdminPageProps {
  children: ReactNode;
  className?: string;
}

export default function LayerAdmin({
  children,
  className,
}: AdminPageProps) {
  const [open, setOpen] = useState(false);

  const openClose = () => {
    setOpen(!open);
  };

  const [isRTL, setIsRTL] = useState(false);

  const lang = currentLang();
  useEffect(() => {
    let isRtl = false;
    if(lang === "Arabic") isRtl = true 
    else isRtl = false;
    setIsRTL(isRtl);
  }, [lang]);

  return (
    <>
      <>
        <Header openClose={openClose} />
        <AdminNavbar open={open} setOpen={setOpen} />
        <div
          className={`relative pt-[25px] h-[calc(100vh-48px)] flex-grow overflow-y-auto scrollbar scrollbar-thin pb-8 md:pb-0 ${
            isRTL ? "md:pr-[74px]" : "md:pl-[74px]"
          }`}
        >
          {children}
        </div>
      </>
    </>
  );
}
